import {
  authReq
} from '@/utils/http'

const getFactories = (page = 1, pageSize = 10, sort = '', filters = {}) => {
  return authReq.get('/api/v1/factory', {
    'page_size': pageSize,
    page,
    sort,
    ...filters
  })
}

const getAdvRegistries = (page = 1, pageSize = 10, sort = '', filters = {}) => {
  return authReq.get('/api/v1/factory/adv_registry', {
    'page_size': pageSize,
    page,
    sort,
    ...filters
  })
}

const batchAddAdvRegistries = (count, type, goodsLength) => {
  return authReq.post('/api/v1/factory/adv_registry/batch_add', {
    count,
    type,
    'goods_length': goodsLength
  })
}

const batchBindAdvRegistries = (userid, sns, clientids, factoryId, title, platform, protocol, connEncry) => {
  return authReq.post('/api/v1/factory/adv_registry/batch_bind', {
    userid,
    sns,
    clientids,
    'factory_id': factoryId,
    title,
    platform,
    protocol,
    'conn_encry': connEncry
  })
}

export default {
  getFactories,
  getAdvRegistries,
  batchAddAdvRegistries,
  batchBindAdvRegistries
}



// WEBPACK FOOTER //
// ./src/api/factoryApi.js